<template>
  <div>
    <crumb-tit>
      <span slot="breadTit">{{ $t('message["1365"]') }}</span>
      <span slot="secondTit">{{ $t('message["1365"]') }}</span>
    </crumb-tit>
    <div class="relation-tabs-box">
      <a-tabs
        v-model="key"
        :animated="false"
        @change="callback"
      >
        <a-tab-pane
          key="1"
          :tab="overviewTitTxt"
          force-render
        >
          <re-list v-if="type==='list'" />
        </a-tab-pane>
        <a-tab-pane
          key="2"
          :tab="settingTitTxt"
          force-render
        >
          <re-info v-if="type==='info'" />
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>
<script>
import CrumbTit from '@/components/pc/config/CrumbTit'
import ReList from './ReList'
import ReInfo from './ReInfo'
export default {
  components: {
    ReList,
    ReInfo,
    CrumbTit
  },
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      key: this.type === 'list' ? '1' : '2'
    }
  },
  computed: {
    overviewTitTxt () {
      return this.$t('message["346"]')
    },
    settingTitTxt () {
      return this.$t('message["695"]')
    }
  },
  methods: {
    callback (key) {
      this.LinkPath = key === '1'
        ? 'configRelationList'
        : 'configRelationInfo'
      this.$router.push({
        name: this.LinkPath
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .relation-tabs-box::v-deep {
    border-top: 1px solid #ebebeb;
    font-size: 18px;
    margin-top: 16px;
    .ant-tabs-bar {
      border-bottom: none 0;
    }
    .ant-tabs-nav .ant-tabs-tab {
      font-size: 18px;
      font-weight: bold;
      margin-right: 0;
    }
  }
</style>
